import React from 'react'
// import Img from 'gatsby-image'
import Link from 'gatsby-link'
// import hero1 from './hero1.jpeg'
import styles from './hero.module.css'
import './hero.module.css'

const data = {
  headline: " adalah Gerakan Anak Muda Kristiani yang cinta akan Ajaran Iman Gereja yang benar demi menjadi saksi iman di dalam Gereja dan masyarakat"
}

export default () => (
  <div className="hero">
    <div className={styles.heroImage}>
      <a href='https://40hariniatbaik.youcat.id/' target='_blank' rel="noreferrer">
        <img src="https://static.youcat.id/website/banners/banner.jpg" srcSet="https://static.youcat.id/website/banners/banner.jpg 1920w, https://static.youcat.id/website/banners/banner1024.jpg 1024w, https://static.youcat.id/website/banners/banner768.jpg 768w, https://static.youcat.id/website/banners/banner480.jpg 480w" alt="40 Hari Niat Baik" title="40 Hari Niat Baik" />
      </a>
    </div>
    <div className={styles.viewButton}>
      <a href='https://40hariniatbaik.youcat.id/'>
        <h2>Ayo ikutan! Ketuk disini yah!</h2>
      </a>
    </div>
  </div>
)


{/* 

const data = {
  headline: " adalah Gerakan Anak Muda Kristiani yang cinta akan Ajaran Iman Gereja yang benar demi menjadi saksi iman di dalam Gereja dan masyarakat"
}

  <div className="cell shrink heroImage">
      <div className={styles.heroImageContent}></div>
    </div>
    <div className="cell medium-auto heroDetails" style={{ "position": "relative" }}>
      <div className={styles.heroDetailsInner}>
        <h1 className={styles.heroFirst}>
          Mau #Beriman yang #BukanRecehan?
        </h1>
        <h3 className={styles.heroHeadline}>
          <span className="youcatWhite">
            <img src={'https://static.youcat.id/logo/youcat-white.svg'} alt="YOUCAT" title="YOUCAT" />
          </span> 
          {data.headline}
        </h3>
        <div className={styles.heroAction}>
          <a href="/about" className={styles.whiteButton}>Lebih Lanjut</a>
        </div>
      </div>
    </div>
  

  
  */}


// WEBPACK FOOTER //
// ./src/components/hero.js